@let type = value().type;
@let label = value().label;

@switch (type) {
  @case ('default') {
    <glxy-badge>{{ label }}</glxy-badge>
  }
  @case ('nav') {
    <glxy-badge color="blue">{{ label }}</glxy-badge>
  }
  @case ('beta') {
    <glxy-badge color="green">{{ label }}</glxy-badge>
  }
}
